import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "count", "check", "all" ]

  connect() {
    this.checkTargets.forEach(t => {
     t.addEventListener('change', this.count.bind(this))
    })
  }

  count() {
    var c = 0
    this.checkTargets.forEach(t => { if (t.checked) c++ })
    this.countTarget.innerHTML = c
  }

}
